import { render, staticRenderFns } from "./TerritoryExcludedPostalCodes.vue?vue&type=template&id=07be719a&"
import script from "./TerritoryExcludedPostalCodes.vue?vue&type=script&lang=ts&"
export * from "./TerritoryExcludedPostalCodes.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports